import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseWaveByIdOptions {
  readonly enabled?: boolean | undefined;
}
export function useWaveById(waveId, t0) {
  const $ = _c(16);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  let t4;
  if ($[2] !== waveId) {
    t3 = [QueryKey.WAVE, {
      wave_id: waveId
    }];
    t4 = async () => {
      if (!waveId) {
        throw new Error("Cannot fetch wave without a wave id");
      }
      return await commonApiFetch({
        endpoint: `waves/${waveId}`
      });
    };
    $[2] = waveId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = Boolean(enabled && waveId);
  let t6;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 60000,
      placeholderData: _temp
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    data: wave,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useQuery(t6);
  let t7;
  if ($[9] !== error || $[10] !== isError || $[11] !== isFetching || $[12] !== isLoading || $[13] !== refetch || $[14] !== wave) {
    t7 = {
      wave,
      isLoading,
      isError,
      error,
      refetch,
      isFetching
    };
    $[9] = error;
    $[10] = isError;
    $[11] = isFetching;
    $[12] = isLoading;
    $[13] = refetch;
    $[14] = wave;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(prev) {
  return prev;
}